export enum QueryKeys {
  ACTIVE_RETAILERS = 'active_retailers',
  HAS_POINTS_HISTORY = 'has_points_history',
  GET_ACTIVE_PROGRAM_FOR_RETAILER = 'get_active_program_for_retailer',
  GET_ADMINS = 'get_admins',
  GET_ASSOCIATED_SELLERS = 'get_associated_selleries',
  GET_BOOKING = 'get_booking',
  GET_CATEGORY = 'category',
  GET_DASHBOARD_DATA = 'get_dashboard_data',
  GET_DASHBOARD_ORDERS = 'get_dashboard_orders',
  GET_DASHBOARD_SALESPERSONS = 'get_dashboard_salespersons',
  LIST_BOOKINGS = 'list_bookings',
  GET_EARLIEST_SYNC_TRANSACTION_DATE = 'get_earliest_sync_transaction_date',
  GET_ENERGY_ACTIVITY = 'get_energy_activity',
  GET_ENERGY_CUSTOMER = 'get_energy_customer',
  GET_ENERGY_DASHBOARD = 'get_energy_dashboard',
  GET_ENERGY_PROGRAM = 'get_energy_program',
  GET_ENERGY_REVERSE_PREVIEW = 'get_energy_reverse_preview',
  GET_FARMER_REWARDS = 'get_farmer_rewards',
  GET_FARMER_REWARDS_FOR_DASHBOARD = 'get_farmer_rewards_for_dashboard',
  GET_FARMERS = 'get_farmers',
  GET_FEATURE_FLAGS = 'get_feature_flags',
  GET_IMPORT_HISTORY_LIST = 'get_import_history_list',
  GET_IMPORT_PROCESSING_RESULT = 'get_import_processing_result',
  GET_IMPORT_IS_IMPORTING = 'get_import_is_importing',
  GET_JOB_IS_PROCESSING = 'get_job_is_processing',
  GET_LATEST_PROCESSED_ORDER_DATE = 'get_latest_processed_order_date',
  GET_LINKED_ACCOUNTS = 'get_linked_accounts',
  GET_LOCATIONS = 'get_locations',
  GET_LOCATION_BY_ID = 'get_location_by_id',
  GET_LOCATION_MEMBERS = 'get_location_members',
  GET_LOYALTY_PROGRAM_METADATA = 'get_loyalty_program_metadata',
  GET_LOYALTY_SKUS = 'get_loyalty_skus',
  GET_MANUFACTURER_BY_ID = 'get_manufacturer_by_id',
  GET_MANUFACTURERS = 'get_manufacturers',
  GET_MANUFACTURERS_LIST = 'manufacturers',
  GET_NOTIFICATION_STATS = 'get_notification_stats',
  GET_NOTIFICATION_VALUES = 'get_notification_values',
  GET_NOTIFICATIONS = 'get_notifications',
  GET_ORDER = 'get_order',
  GET_ORDERS = 'get_orders',
  GET_ORDERS_HAS_TRANSACTION_SUBTYPES = 'get_orders_has_transaction_subtypes',
  GET_POINTS_KPIS = 'get_points_kpis',
  GET_POINTS_METRICS = 'get_points_metrics',
  GET_POINTS_KPIS_BY_CUSTOMER = 'get_points_kpis_by_customer',
  GET_POINTS_OVERVIEW = 'get_points_overview',
  GET_POINTS_OVERVIEW_FILTER_OPTIONS = 'get_points_overview_filter_options',
  GET_PRODUCT = 'product',
  GET_PRODUCT_EXCLUSIONS = 'get_product_exclusions',
  GET_PRODUCT_PURCHASE_IMPACT = 'get_product_purchase_impact',
  GET_PRODUCTS = 'get_products',
  GET_PROMOTION = 'get_promotion',
  GET_PROMOTIONS = 'get_promotions',
  GET_PROMOTIONS_FOR_RETAILER = 'get_promotions_for_retailer',
  GET_REPORT = 'get_report',
  GET_RETAILER_FARMERS_BY_ID = 'get_retailer_farmers_by_id',
  GET_RETAILERS = 'get_hierarchy_of_retailers',
  GET_RETAILER_BY_ID = 'get_hierarchy_of_retailers_by_id',
  GET_RETAILER_ASSOCIATED_FARMERS = 'get_retailer_associated_farmers',
  GET_RETAILER_CATEGORIES = 'get_retailer_categories',
  GET_RETAILER_CATEGORY_MAPPINGS = 'get_retailer_category_mappings',
  GET_RETAILER_ERP_CATEGORIES = 'get_retailer_erp_categories',
  GET_RETAILER_FOR_DASHBOARD = 'get_retailer_for_dashboard',
  GET_RETAILER_HAS_ELIGIBLE_PROMOTIONS = 'get_retailer_has_eligible_promotions',
  GET_RETAILER_INTEGRATION = 'get_retailer_integration',
  GET_RETAILER_LOCATION_LIST = 'get_retailer_location_list',
  GET_RETAILER_MEMBERS = 'get_retailer_members',
  GET_RETAILER_TWILIO_CONFIG = 'get_retailer_twilio_config',
  GET_REWARDS_PROGRAM_FOR_DASHBOARD = 'get_rewards_program_for_dashboard',
  GET_REWARDS_PROGRAM_HAS_ACTIVE_USERS = 'get_rewards_program_has_active_users',
  GET_REWARDS_PROGRAM_HAS_POINTS_ENGINE_BEEN_RUN = 'get_rewards_program_has_points_engine_been_run',
  GET_SCHEDULED_NOTIFICATIONS = 'get_scheduled_notifications',
  GET_SCHEDULED_NOTIFICATION = 'get_scheduled_notification',
  GET_EXCLUDED_CUSTOMERS_COUNT = 'get_excluded_customers_count',
  GET_SUBWALLET = 'get_subwallet',
  GET_INTEGRATION_SYNC_HISTORY = 'get_integration_sync_history',
  GET_INTEGRATION_SYNC_STATUS = 'get_integration_sync_status',
  GET_TIER_CUSTOMER_COUNT = 'get_tier_customer_count',
  GET_CHURN_CUSTOMER_COUNT = 'get_churn_customer_count',
  GET_UOM = 'UoM',
  GET_USER = 'get_user',
  GET_WALLETS = 'get_wallets',
  LIST_COUNTIES = 'list_counties',
  LIST_CUSTOMER_OVERVIEW = 'list_customer_overview',
  LIST_REWARDS_PROGRAMS = 'list_rewards_programs',
  LIST_POINTS_FOR_PROGRAM_PERIOD = 'list_points_for_program_period',
  LIST_PRIMARY_CUSTOMERS = 'list_primary_customers',
  LIST_REDEEMABLE_PRODUCTS = 'list_redeemable_products',
  LIST_REPORTS = 'list_reports',
  LIST_RETAILER_RECIPIENTS = 'list_retailer_recipients',
  LIST_SUBWALLETS = 'list_subwallets',
  LIST_SUBWALLET_PROGRAM_YEARS = 'list_subwallet_program_years',
  LIST_SUBWALLET_BALANCES = 'list_subwallet_balances',
  LIST_TIER_CUSTOMERS = 'list_tier_customers',
  LIST_TRANSACTION_POINTS_HISTORY = 'list_transaction_points_history',
  LIST_USERS = 'list_users',
  LIST_USER_SYNC = 'list_user_sync',
  GET_USER_SYNC_ALIGN_PROGRESS = 'get_user_sync_align_progress',
  VALIDATE_TOKEN = 'validate_token',
  LIST_RECIPIENTS = 'list_recipients',
  LIST_RECIPIENTS_FILTER = 'list_recipients_filter',
  FETCH_RECIPIENT_COUNT = 'fetch_recipient_count',
  GET_DRAFT_NOTIFICATIONS = 'get_draft_notifications',
  RECIPIENTS_COUNT = 'recipients-count',
  PREVIEW_NOTIFICATION_MESSAGE = 'preview_notification_message',
  GET_POINTS_AUDIT_LOG = 'points_audit_log',
  GET_POINTS_AUDIT_PROCESSES = 'points_audit_processes',
  GET_POINTS_AUDIT_SUMMARY = 'points_audit_summary',
  GET_USER_INSPECTION = 'get_user_inspection',
  QUERY_USER_ACCOUNTS = 'query_user_accounts',
}
